import { Row, Col, Tooltip, Layout, Typography } from "antd";
import { FormattedMessage } from "react-intl";

import setting from "../../../../package.json";

import "./index.css";

const year = new Date().getFullYear();

const { Text } = Typography;

const Footer = () => (
  <Layout.Footer className="footer">
    <Row justify="center" className="footer-row">
      <Col className="center">
        <Tooltip
          title={
            <FormattedMessage
              id="footer.version"
              defaultMessage="verze webové aplikace {version}"
              values={{ version: setting.version }}
            />
          }
        >
          <Text>
            <FormattedMessage
              id="footer.rights"
              defaultMessage="{year} © DHL International GmbH. Všechna práva vyhrazena."
              values={{ year }}
            />
          </Text>
        </Tooltip>
      </Col>
    </Row>
  </Layout.Footer>
);

export default Footer;
